import React, { useEffect, useState } from 'react'
import BackButton from 'components/BackButton'
import { useRouteMatch } from "util/router.js";
import { apiRequest } from 'util/api/util'
import Card from 'react-bootstrap/Card';
import Avatar from 'react-avatar'
import { useAuth } from 'util/auth'
import Spinner from 'react-bootstrap/Spinner'
import * as moment from 'moment-timezone'
import ReactTable from "react-table";
import Button from 'react-bootstrap/Button';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton'
import Modal from 'react-bootstrap/Modal'
import { useForm, Controller } from "react-hook-form";
import * as yup from 'yup';
import { useSelector } from 'react-redux';
import FormGroup from 'components/Form/FormGroup'
import FormDatePicker from 'components/Form/FormDatePicker'
import StatusPill from 'components/StatusPill'
import { DevTool } from "react-hook-form-devtools";
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import DropdownButton from 'react-bootstrap/DropdownButton'
import Dropdown from 'react-bootstrap/Dropdown'
import SweetAlert from 'react-bootstrap-sweetalert'
import CardSection from 'components/CardSection';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
const DATE_FORMAT = 'ddd MMM D, YYYY';

function AddNewPaymentMethod(props) {


    const auth = useAuth()
    const stripe = useStripe()
    const elements = useElements()
    const [isSaving, setIsSaving] = React.useState(false)

    const stripeAccount = auth?.stripePartner?.account_id

    const { clientId } = props
    const partnerId = useSelector(state => state.user.userData.platformID);

    const onConfirm = async () => {

        if (!stripeAccount) {
            window.alert("Please connect your Stripe account before continuing")
            return
        }

        setIsSaving(true)

        const cardElement = elements.getElement(CardElement);

        const paymentMethodReq = await stripe.createPaymentMethod({
            type: 'card',
            card: cardElement
        }, {
            stripeAccount: stripeAccount
        })

        if (paymentMethodReq.error?.message) {
            setIsSaving(false)
            window.alert(paymentMethodReq.error.message)
            return
        }

        let paymentMethod = paymentMethodReq?.paymentMethod?.id

        // console.log("POST BODY: ", body)

        apiRequest(`clients/updateClient/paymentMethod`, "POST", {
            clientId: clientId,
            partnerId: partnerId,
            isNew: true,
            paymentMethod: paymentMethod
        })
            .then(async data => {

                setIsSaving(false)
                props.onHide()

                props.onSuccess()
            })
            .catch(err => {
                setIsSaving(false)
                if (err.message) {
                    window.alert(err.message)
                }
            })
    }

    return (
        <Modal show={props.show} onHide={() => {
            setIsSaving(false)
            props.onHide()
        }}>
            <Modal.Header closeButton={!isSaving}>
                Add New Payment Method
            </Modal.Header>
            <Modal.Body>
                <CardSection className="w-100 mb-5" />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onConfirm}>
                    {isSaving && (
                        <Spinner
                            animation="border"
                            size="sm"
                            aria-hidden={true}
                            className="ml-2"
                        >
                        </Spinner>
                    )}
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    )
}


function PaymentMethodCell({ paymentMethod, onDelete, onSetDefault }) {

    var view = paymentMethod.id ? (
        <div className="d-flex d-row align-itmes-center">
            <h5 className="my-auto mr-2">
                <i className="fas fa-credit-card" ></i>
            </h5>
            <div className="mr-2">
                <h6 className="mb-1">
                    <span>&nbsp;{paymentMethod.card.brand.toUpperCase()}</span>
                    <small>&nbsp;&#183;&#183;&#183;&#183;{paymentMethod.card.last4}</small>
                </h6>
                <p className="mb-0">&nbsp;Expires {paymentMethod.card.exp_month} / {paymentMethod.card.exp_year}</p>
            </div>
            {paymentMethod.isDefaultPaymentMethod && (
                <StatusPill
                    status="blue"
                    text="default"
                />
            )}
        </div>
    ) : (
            <h6 className="my-0">New Card</h6>
        )

    return (
        <div onClick={() => { }} className={`w-100 p-2`}>
            <div className="d-flex d-row justify-content-between align-items-center">
                {view}
                <DropdownButton size="sm" as={ButtonGroup} title="" id="bg-nested-dropdown">
                    <Dropdown.Item onClick={onSetDefault} disabled={paymentMethod.isDefaultPaymentMethod} eventKey="1">Set as default</Dropdown.Item>
                    <Dropdown.Item onClick={onDelete} className="danger" eventKey="2">Delete</Dropdown.Item>
                </DropdownButton>
            </div>

            <hr></hr>
        </div>

    )
}

function PaymentMethods(props) {

    const NOW_TIMESTAMP = moment().unix()

    const auth = useAuth()

    const [isLoading, setIsLoading] = React.useState(true)
    const [paymentMethods, setPaymentMethods] = React.useState([])

    const { clientId } = props
    const partnerId = useSelector(state => state.user.userData.platformID);
    const [addingNew, setAddingNew] = React.useState(false)
    const [alert, setAlert] = React.useState(null)

    useEffect(() => {

        if (!clientId || !auth.userData || !partnerId) {
            console.log("instructor: ", partnerId)
            return
        }

        console.log("making request")
        fetchPaymentMethods(partnerId)

    }, [partnerId])

    const fetchPaymentMethods = () => {

        setIsLoading(true)
        apiRequest(`clients/getClient/paymentMethods?clientId=${clientId}&partnerId=${partnerId}`, "POST", {
            clientId: clientId,
            partnerId: partnerId
        })
            .then(data => {
                setPaymentMethods(data)
                setIsLoading(false)
            })
            .catch(err => {
                setIsLoading(false)
            })

    }

    console.log("METHODS: ", paymentMethods)

    const viewModel = {
    }

    const confirmDelete = (pm_id, onFinish) => {

        apiRequest(`clients/updateClient/deletePaymentMethod`, "POST", {
            clientId: clientId,
            partnerId: partnerId,
            paymentMethod: pm_id
        })
            .then(data => {
                fetchPaymentMethods()
                onFinish()
            })
            .catch(err => {
                setIsLoading(false)
                console.log(err?.message ?? "Error deleting payment methodl")
            })
    }

    const handleDelete = (pm_id) => {

        setAlert(
            <SweetAlert
                warning
                showCancel
                confirmBtnText="Yes, delete it!"
                confirmBtnBsStyle="danger"
                title="Are you sure?"
                onConfirm={() => {
                    confirmDelete(pm_id, () => {
                        setAlert(false)
                    })

                }}
                onCancel={() => {

                    setAlert(false)
                }}
                focusCancelBtn
            >
                You will not be able to recover this payment method!
            </SweetAlert>
        )

    }

    const confirmSetDefault = (pm_id, onFinish) => {

        setIsLoading(true)

        apiRequest(`clients/updateClient/paymentMethod`, "POST", {
            clientId: clientId,
            partnerId: partnerId,
            isNew: false,
            paymentMethod: pm_id
        })
            .then(data => {
                fetchPaymentMethods()
                setIsLoading(false)
                onFinish()
            })
            .catch(err => {
                setIsLoading(false)
                if (err.message) {
                    window.alert(err.message)
                }
            })

    }

    const handleSetDefault = (pm_id) => {

        setAlert(
            <SweetAlert
                warning
                showCancel
                confirmBtnText="Modify Default"
                confirmBtnBsStyle="danger"
                title="Are you sure?"
                onConfirm={() => {
                    confirmSetDefault(pm_id, () => {
                        setAlert(false)
                    })

                }}
                onCancel={() => {

                    setAlert(false)
                }}
                focusCancelBtn
            >
                By changing the default payment method all future subscriptions charges will use this payment method
            </SweetAlert>
        )

    }

    return (<>
        {alert}
        <AddNewPaymentMethod
            clientId={clientId}
            show={addingNew}
            onHide={() => {
                setAddingNew(false)
            }}
            onSuccess={() => {
                fetchPaymentMethods()
            }}
        />
        <div className="d-flex d-row justify-content-between">
            <h4 className="mr-2">Payment Methods</h4>
            <button type="button" className="btn btn-link"
                onClick={() => {
                    setAddingNew(true)
                }}
            >
                Add
            </button>
        </div>

        {paymentMethods && paymentMethods.map(val => {
            return <PaymentMethodCell
                key={val.id}
                paymentMethod={val}
                onDelete={() => {
                    handleDelete(val.id)
                }}
                onSetDefault={() => {
                    handleSetDefault(val.id)
                }}
            />
        })}

    </>)
}

export default PaymentMethods;